import {
  ConsentActions,
  ConsentApiRequestModel,
  ConsentRequestModel,
} from './consent.model';
import { publicConfig } from '../../services';
import { RegionsEnum } from '../../models';

export const mapAdvMailingsRequestParams = ({
  agreement,
  email,
  kind,
  name,
  phone,
}: ConsentRequestModel): ConsentApiRequestModel => {
  const isRuRegion = publicConfig?.REGION === RegionsEnum.ru;
  const requestParams: ConsentApiRequestModel = {
    action: isRuRegion
      ? agreement
        ? ConsentActions.agreed
        : ConsentActions.refused
      : ConsentActions.agreed,
    kind,
  };
  if (email) {
    requestParams.email = email;
  }
  if (name) {
    requestParams.name = name;
  }
  if (phone) {
    requestParams.phone = phone;
  }
  return requestParams;
};
